import { grommet } from "grommet";
import { deepMerge } from "grommet/utils";

const theme = deepMerge(grommet, {
    global: {
      colors: {
        brand: '#030B33',
        focus: '#BA24FF',
        active: '#BA24FF',
        text: '#fff',
        background: 'brand',

      },
      font: {
        family: "'Inter', Roboto, Arial",
        src: 'https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2',
        size: "18px",
        height: "20px",
      }
    },
    carousel: {
      animation: {
        duration: 600,
      },
      icons: {
        color: 'focus',
        /*next: CaretRightFill,
        previous: CaretLeftFill,*/
      },

    },
    select: {
      icons: {
        color: 'focus'
      }
    },
    ul: {
      zIndex: 2
    },
    li: {
      zIndex: 2
    },
    list: {
      zIndex: 2
    },
    tip: {
      content: {
        background: 'linear-gradient(180deg, rgba(208, 208, 208, 0.65) 0%, rgba(247, 248, 249, 0.65) 100%);',
        color: '#030B33',
        opacity: 1
      }
    }
  });

export { theme }
